import React, { memo } from 'react';
import Tooltip from '@material-ui/core/Tooltip';

export const TooltipWrapper = memo(({ children, val, classes }) => (
  <Tooltip
    classes={{
      tooltipPlacementTop: classes.tooltipPlacementTop,
    }}
    title={val}
    placement="top"
    enterDelay={600}
  >
    {children}
  </Tooltip>
));
